/**
 * Stable CSS class names for E2E — Criteria type create/edit modal.
 */
export const CTM = {
    modalRoot: 'criteria-type-modal',
    modalPaper: 'criteria-type-modal__paper',
    modalTitle: 'criteria-type-modal__title',
    modalCloseButton: 'criteria-type-modal-input--button-close',
    modalCloseIcon: 'criteria-type-modal__close-icon',

    form: 'criteria-type-modal__form',
    formGrid: 'criteria-type-modal__form-grid',

    fieldKey: 'criteria-type-modal-input__key',
    fieldName: 'criteria-type-modal-input__name',
    fieldTenant: 'criteria-type-modal-input__tenant',

    radioSection: 'criteria-type-modal__radio-section',
    radioLabel: 'criteria-type-modal__radio-label',
    radioGroup: 'criteria-type-modal-input__radio-group',
    radioApprove: 'criteria-type-modal-input__radio-approve',
    radioDecline: 'criteria-type-modal-input__radio-decline',

    predefinedSection: 'criteria-type-modal__predefined-section',
    addValueButtonWrap: 'criteria-type-modal__add-value-button-wrap',
    addValueButton: 'criteria-type-modal-input--button-add-value',
    valueRows: 'criteria-type-modal__value-rows',
    valueRow: 'criteria-type-modal__value-row',
    valueNameField: 'criteria-type-modal-input__value-name',
    valueValueField: 'criteria-type-modal-input__value-value',
    removeValueButton: 'criteria-type-modal-input--button-remove-value',
    removeValueIcon: 'criteria-type-modal__remove-value-icon',
} as const;

export const ctmCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

